import { Button, Skeleton, Stack } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { Link } from "react-router-dom";
import Avatar from "../Avatar";

export const SailorCell = ({ sailorRef, applicationRef }) => {
  const [sailor, loading, error] = useDocumentData(sailorRef);
  const sailorName = sailor ? `${sailor.firstName} ${sailor.lastName}` : "";
  return (
    <TableCell sx={{ display: "flex", alignItems: "center" }}>
      <Stack
        style={{
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
        }}
        flexDirection="row"
      >
        <Avatar
          firstName={sailor?.firstName}
          lastName={sailor?.lastName}
          loading={loading}
          error={error}
          sx={{ mr: 2 }}
        />
        {loading ? <Skeleton variant="text" sx={{ flex: 1 }} /> : sailorName}
        <Stack direction="row" sx={{ ml: 4 }}>
          <Button
            component={Link}
            to={`/applications/${applicationRef?.id}/agreement-sailors/${sailorRef?.id}`}
            sx={{ mr: 2 }}
            variant="outlined"
          >
            View Application Sailor Record
          </Button>
          <Button
            component={Link}
            to={`/sailors/${sailorRef?.id}`}
            sx={{ mr: 2 }}
            variant="outlined"
          >
            View Current Sailor
          </Button>
        </Stack>
      </Stack>
    </TableCell>
  );
};
